import React, { useState, useContext } from 'react'
import Lottie from 'react-lottie'
import PropTypes from 'prop-types'
import { useNavigate, useLocation } from 'react-router-dom'
// import { ReactComponent as CheilLogodarkBg } from 'assets/images/cheil-logo-on-dark.svg'

import { MAIN_MENU } from 'assets/common/constants'
import { colors } from 'assets/common/colors'
import { Menu, Button } from 'components'
import { Context } from 'store'
import { showContactForm } from 'store/actions'
import {
  useMotionValueEvent,
  useScroll,
  useSpring,
  useTransform
} from 'framer-motion'
import {
  StyledNavigationWrapper,
  StyledNavigation,
  StyledLogoContainer,
  StyledNavigationItemsContainer,
  StyledNavigationItem,
  StyledContactButtonContainer,
  StyledContactButton,
  StyledMenuLine,
  StyledBurgerContainer,
  StyledBurger
} from './Navigation.styled'
import cheilLogoWhite from '../../assets/lotties/cheilLogoWhite.json'

const { mint, yellow, magenta, green } = colors

const menuColors = [mint, yellow, magenta, green]

const Burger = ({ open, setOpen }) => {
  return (
    <>
      <StyledBurgerContainer
        whileHover={{
          rotate: open ? 90 : 0
        }}
        style={{ position: open ? 'fixed' : 'inherit' }}
      >
        <StyledBurger open={open} onClick={() => setOpen(!open)}>
          <StyledMenuLine />
          <StyledMenuLine />
          <StyledMenuLine shorter />
        </StyledBurger>
      </StyledBurgerContainer>
      {/* This is a placeholder so the layout doesn't shift and the real button can follow the menu scrolling as a position fixed component */}
      {open && (
        <StyledBurgerContainer style={{ zIndex: -10, pointerEvents: 'none' }}>
          <StyledBurger open={false}>
            <StyledMenuLine />
            <StyledMenuLine />
            <StyledMenuLine shorter />
          </StyledBurger>
        </StyledBurgerContainer>
      )}
    </>
  )
}

const Navigation = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [open, setOpen] = useState(false)
  const node = React.useRef()
  const { dispatch } = useContext(Context)
  const { scrollY } = useScroll()
  const [direction, setDirection] = useState(-1)

  const transformedScrollY = useTransform(scrollY, [0, 200], [0, 15], {
    clamp: true
  })

  useMotionValueEvent(scrollY, 'change', (latest) => {
    if (latest > 50) {
      setDirection(1)
    } else {
      setDirection(-1)
    }
  })

  const springPhysics = {
    damping: 22,
    mass: 0.1,
    stiffness: 200,
    bounce: 0.5,
    duration: 0.4,
    velocity: 100
  }

  const transformScaleX = useTransform(scrollY, [0, 300], [1, 0.2], {
    clamp: true
  })

  const transformScaleY = useTransform(scrollY, [0, 300], [1, 0.8], {
    clamp: true
  })

  const transformSlideX = useTransform(scrollY, [0, 300], [0, 75], {
    clamp: true
  })

  const positionY = useSpring(transformedScrollY, springPhysics)

  const defaultLottieOptions = (lottie) => {
    return {
      loop: false,
      autoplay: false,
      animationData: lottie,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    }
  }

  return (
    <StyledNavigationWrapper>
      <StyledNavigation>
        <StyledLogoContainer id="cheil-logo" open={open}>
          <Lottie
            options={defaultLottieOptions(cheilLogoWhite)}
            onClick={() => navigate('/')}
            direction={direction}
          />
        </StyledLogoContainer>
        <StyledNavigationItemsContainer
          style={{
            y: positionY
          }}
        >
          {MAIN_MENU.map((item, index) => (
            <StyledNavigationItem
              key={item}
              onClick={() => navigate(`/${item}/`)}
              iscurrent={pathname === `/${item}` ? 'true' : undefined}
              content={item}
              color={menuColors[index]}
            >
              {item}
              <span color={menuColors[index]}>{item}</span>
            </StyledNavigationItem>
          ))}
        </StyledNavigationItemsContainer>
        <StyledContactButtonContainer>
          <StyledContactButton
            style={{
              originX: 'right',
              scaleX: transformScaleX,
              x: transformSlideX,
              scaleY: transformScaleY
            }}
          >
            <Button
              handleClick={() => dispatch(showContactForm(true))}
              textButton="Contact us"
            />
          </StyledContactButton>
          <StyledBurgerContainer ref={node}>
            <Burger open={open} setOpen={setOpen} />
            <Menu open={open} setOpen={setOpen} />
          </StyledBurgerContainer>
        </StyledContactButtonContainer>
      </StyledNavigation>
    </StyledNavigationWrapper>
  )
}

Burger.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired
}

export default Navigation
